import { Carousel } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useCallback, useEffect } from 'react'

import 'bootstrap/dist/css/bootstrap.css'
import styles from './styles.module.scss'

import { courseStore } from '@/stores/course.store'
import { StorageService } from '@/services/storage'
import { Image } from '@/domain/entities/image.entity'
import { useDownload } from '@/pages/@hooks/use-download'
import { institutionStore } from '@/stores/institution.store'
import { imageCoursesStore } from '@/stores/image-courses.store'
import { InstitutionRepository } from '../../admin/repositories/institution.repository'

import { Map } from '../map'
import { Details } from '../details'

const storageService = new StorageService()

export function CursoPage() {
  const { id } = useParams()
  const { download } = useDownload({ storageService })

  const { course, setCourse } = courseStore()
  const { institution, setInstitution } = institutionStore()
  const { imagesCourses, setImagesCourses } = imageCoursesStore()

  const images = useCallback(async (images: Image[]) => {
    const promises = images.map((image) => download(image.filename))
    const _images = await Promise.all(promises)
    const urls = _images.map((image, index) => ({
      url: image[0]?.url,
      id: course?.Institution?.Images?.[index]?.id,
    }))
    setImagesCourses(urls)
  }, [])

  const fetchCurso = useCallback(async () => {
    const { course } = await InstitutionRepository.GetInstance().getCursoById(
      Number(id),
    )
    setCourse(course)
    setInstitution(course.Institution)
    images(course.Institution.Images)
  }, [])

  useEffect(() => {
    fetchCurso()
  }, [])

  return course && institution ? (
    <div className={styles.container}>
      <div className={styles.content}>
        <Map course={course} institution={institution} />
        <Details course={course} institution={institution} />
      </div>

      <div className={styles.grid}>
        <div>
          <h4 className={styles.h4}>Sobre o {institution?.title}</h4>
          <p>{institution?.description}</p>
          <p>{institution?.description_2}</p>
          <p>{institution?.description_3}</p>
        </div>
        <Carousel className={styles.carousel}>
          {imagesCourses &&
            imagesCourses?.map((image) => {
              return (
                <Carousel.Item key={image.id}>
                  <img height={150} src={image.url} />
                </Carousel.Item>
              )
            })}
        </Carousel>
      </div>
    </div>
  ) : (
    <h1>Curso nao encontrado</h1>
  )
}
